import { ajax } from '@platform/api';

// 这里是抄的以前的，看不懂
export function createUpdateAfterBatchChange({
    getStore,
    updateAndAddRows,
}) {
    function updateAfterBatchChange(param) {
        let {
            areaCode,
            column,
            indexs,
            queryValue,
            changedrows,
            pasteData,
            queryCondition: customQueryCondition,
            isManyCondition,
            extraAjaxParam = {},
        } = param;
    
        let rowKey = 'rowid',
            pageScope = this,
            store = getStore.call(this, areaCode),
            rows = store.getRows(),
            newRowsCount = 0;
    
        // 处理一遍indexs
        if (queryValue && queryValue.length > 0) {
            let newIndexes = [];
            queryValue.forEach(row => {
                if (!row) {
                    return;
                }
                // 如果领域返回的数字类型精度不正确，做一次四舍五入
                let scale = Math.max(row.values[column.attrcode].scale, column.scale);
                if (column.itemtype === 'number' && scale) {
                    row.values[column.attrcode].value = row.values[column.attrcode].value && formatAccuracyNumber(row.values[column.attrcode].value, scale);
                }
                newIndexes.push(store.getRowData(row.rowid)?.dataIndex ?? rows.length + newRowsCount++);
            });
            indexs = newIndexes;
        }
    
        let {
            attrcode,
            itemtype,
            editAfterFlag,
            refcode,
            fieldDisplayed = "refname",
            fieldValued = "refpk",
            queryCondition,
            pk_defdoclist, dataPowerOperationCode, isDataPowerEnable,
            loadSelectedData, //参照需要的属性
        } = column;
    
        if (itemtype === "refer") {
            if (/.js/.test(refcode)) {
                refcode = refcode.replace(".js", "");
            }
            if (!refcode || !window[refcode]) {
                console.error(`window中没有refcode:${refcode}`);
            }
    
            let refer = window[refcode].default();
            let url = refer.props.queryGridUrl || refer.props.queryTreeUrl;
            let referProps = refer.props;
            let { checkStrictly } = referProps;
            if (checkStrictly === false) {
                //摘要走这里
                return new Promise(resolve => {
                    console.error('非严格参照，比如摘要');
                    let newChangedRows = [];
                    queryValue.forEach((row, i) => {
                        let initVal = changedrows[i].oldvalue;
    
                        //摘要这样的参照 value和display都一样
                        let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                        let theValue = {
                            display: row.values[attrcode].value,
                            value: row.values[attrcode].value,
                        };
                        row.values[attrcode].display = row.values[attrcode].value;
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: theValue.value || "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                    });
                    updateAndAddRows.call(pageScope, { rows: queryValue, tableId: areaCode }); //给表格赋值
                    // document.activeElement.blur();
                    resolve({
                        props: pageScope,
                        indexs,
                        key: attrcode,
                        changedrows: newChangedRows,
                    });
                });
            }
            let TreeRefActionExt =
                "nccloud.web.uap.refer.BatchQueryByNameSqlBuilder";
            let GridRefActionExt =
                "nccloud.web.uap.refer.BatchQueryByNameSqlBuilder";
    
            // 模板上会返回下面几个属性
            let extraCondition = {};
            pk_defdoclist !== undefined && (extraCondition.pk_defdoclist = pk_defdoclist);
            dataPowerOperationCode !== undefined && (extraCondition.DataPowerOperationCode = dataPowerOperationCode);
            isDataPowerEnable !== undefined && (extraCondition.isDataPowerEnable = isDataPowerEnable);
            loadSelectedData && (extraCondition.loadSelectedData = true);
    
            let referFilter;
            let otherParams = { queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows };
            if (isManyCondition) {
                let mergeAjaxData = [];
                queryValue.forEach((row, index) => {
                    let ajaxData = [row.values[attrcode].value];
                    let con = row.queryCondition;
                    let datajson = getExcelReferAjaxData(ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam);
                    let data = {
                        rqUrl: url,
                        rqJson: JSON.stringify(datajson),
                        rqCode: String(index),
                    };
                    mergeAjaxData.push(data);
                });
                let urlPaths = (String(url)).split('/');
                let forwardRule = '';
                urlPaths.forEach((item, i) => {
                    if (item === 'nccloud') {
                        forwardRule = urlPaths[i + 1];
                    }
                });
                referFilter = sendExcelReferMergeAjax(mergeAjaxData, otherParams, forwardRule);
            } else {
                let ajaxData = pasteData;
                let con = customQueryCondition;
                let data = getExcelReferAjaxData(ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam);
                referFilter = sendExcelReferNomalAjax(data, url, otherParams);
            }
    
            return referFilter.then(res => {
                let changedrows = res.changedrows;
                let finalValues = res.finalValues;
                let referDatas = res.referDatas;
                let indexs = res.indexs;
                if (editAfterFlag) {
                    pageScope.handleRelationItems({
                        type: "table",
                        areaCode: areaCode,
                        key: attrcode,
                        changedrows,
                        rows: finalValues,
                    });
                } else {
                    updateAndAddRows.call(pageScope, { rows: finalValues, tableId: areaCode }); //给表格赋值
                }
                // document.activeElement.blur();
                return {
                    props: pageScope,
                    key: attrcode,
                    changedrows,
                    referDatas,
                    indexs,
                };
            });
        } else {
            //除了參照以外类型的编辑关联项的处理
            if (editAfterFlag) {
                return new Promise(resolve => {
                    pageScope.handleRelationItems({
                        type: "table",
                        areaCode: areaCode,
                        key: attrcode,
                        changedrows,
                        isMul: true,
                        rows: queryValue,
                    });
                    // document.activeElement.blur();
                    resolve({
                        props: pageScope,
                        changedrows,
                        key: attrcode,
                        indexs,
                    });
                });
            } else {
                return new Promise(resolve => {
                    updateAndAddRows.call(pageScope, { rows: queryValue, tableId: areaCode }); //给表格赋值
                    // 把失焦事件从excel/index.js listenCrtlV方法复制粘贴挪到了这里
                    // 解决日期组件提前失焦导致第一行数据不能粘贴成功的问题
                    // document.activeElement.blur();
                    resolve({
                        props: pageScope,
                        changedrows,
                        key: attrcode,
                        indexs,
                    });
                });
            }
        }
    
        // return new Promise(resolve => {
        //     let { editAfterFlag, attrcode } = column;
    
        //     if (editAfterFlag) {
        //         this.handleRelationItems({
        //             type: "table",
        //             areaCode: areaCode,
        //             key: attrcode,
        //             changedrows,
        //             isMul: true,
        //             rows: queryValue,
        //         });
        //     } 
        //     resolve({
        //         changedrows,
        //         indexs,
        //         key: attrcode,
        //         props: this,
        //     });
        // });
    }
    
    function getExcelReferAjaxData (ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam) {
        let query = {};
        if (typeof queryCondition === 'function') {
            query = Object.assign(
                {},
                queryCondition(refer.props),
                con,
            ); //先是组件的模板上的condition，被业务组注册进来的condition覆盖
        } else if (queryCondition && typeof queryCondition === 'object') {
            query = Object.assign({}, queryCondition, con);
        } else if (queryCondition === undefined) {
            query = Object.assign({}, con);
        }
        if (typeof query.TreeRefActionExt === 'string') {
            if (query.TreeRefActionExt) {
                TreeRefActionExt = query.TreeRefActionExt + "," + TreeRefActionExt;
            }
        }
        if (typeof query.GridRefActionExt === 'string') {
            if (query.GridRefActionExt) {
                GridRefActionExt = query.GridRefActionExt + "," + GridRefActionExt;
            }
        }
        delete query.TreeRefActionExt;
        delete query.GridRefActionExt;
        return {
            pageInfo: {
                pageSize: 50,
                pageIndex: -1,
            },
            keyword: "",
            pid: "",
            defineItems: [],
            queryCondition: {
                batchQueryByName: JSON.stringify({ names: ajaxData }),
                TreeRefActionExt,
                GridRefActionExt,
                ...extraCondition,
                ...query,
            },
            ...extraAjaxParam,
        };
    }
    
    //多个querycondition的参照过滤
    function sendExcelReferMergeAjax (reqData, otherParams, forwardRule = '') {
        return new Promise((resolve, reject) => {
            ajax({
                url: `/nccloud/${forwardRule ? (forwardRule + '/') : ''}platform/pub/mergerequest.do`,
                data: reqData,
                success: res => {
                    let param = { res, ...otherParams };
                    let data = excelReferMergeAjaxSuccess(param);
                    resolve(data);
                },
                error: error => {
                    console.error(error);
                    reject(error);
                },
            });
        });
    }
    
    //一个querycondition的参照过滤
    function sendExcelReferNomalAjax (ajaxdata, url, otherParams) {
        return new Promise((resolve, reject) => {
            ajax({
                url,
                async: false,
                data: { ...ajaxdata },
                success: res => {
                    let param = { res, ...otherParams };
                    let data = excelReferNomalAjaxSuccess(param);
                    resolve(data);
                },
                error: error => {
                    console.error(error);
                    reject(error);
                },
            });
        });
    }
    
    function excelReferMergeAjaxSuccess(param) {
        let { res, queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows } = param;
        let rowKey = 'rowid';
        if (res.data) {
            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];
            Object.keys(res.data).forEach(index => {
                let resValue = res.data[index];
                let row = queryValue[index];
                if (resValue.rows.length) {
                    let cell = row.values[attrcode].value;
                    let finalVal = "";
                    let finalDis = "";
                    let referData;
                    let flag = false;
                    for (let i = 0; i < resValue.rows.length; i++) {
                        let item = resValue.rows[i];
                        //助记码
                        let rememberCode = item.values && item.values.materialmnecode && item.values.materialmnecode.value;
                        if (cell == item['refcode'] || cell == item['refname'] || cell == rememberCode || cell == item[fieldDisplayed]) {
                            finalVal += item[fieldValued];
                            finalDis += item[fieldDisplayed];
                            referData = item;
                            flag = true;
                            break;
                        }
                    }
                    let initVal = changedrows[index].oldvalue;
                    let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                    if (flag) {
                        let theValue = {
                            display: finalDis,
                            value: finalVal,
                        };
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: theValue.value || "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                        //把最终值赋给queryvalue
                        row.values[attrcode].value = finalVal;
                        row.values[attrcode].display = finalDis;
                        ajaxValues.push(row);
                        referData && referDatas.push(referData);
                    } else {
                        let initVal = changedrows[index].oldvalue;
                        let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                        row.values[attrcode].value = "";
                        row.values[attrcode].display = "";
                        ajaxValues.push(row);
                    }
                } else {
                    let initVal = changedrows[index].oldvalue;
                    let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    row.values[attrcode].value = "";
                    row.values[attrcode].display = "";
                    ajaxValues.push(row);
                }
            });
            return {
                indexs: indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
            };
        }
    }
    
    function excelReferNomalAjaxSuccess(param) {
        let { res, queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows } = param;
        let rowKey = 'rowid';
        if (res.data.rows.length) {
    
            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];
    
            queryValue.map((row, index) => {
                let cell = row.values[attrcode].value;
                let finalVal = "";
                let finalDis = "";
                let referData;
                let flag = false;
                for (let i = 0; i < res.data.rows.length; i++) {
                    let item = res.data.rows[i];
                    //助记码
                    let rememberCode = item.values && item.values.materialmnecode && item.values.materialmnecode.value;
                    if (cell == item['refcode'] || cell == item['refname'] || cell == rememberCode || cell == item[fieldDisplayed]) {
                        finalVal += item[fieldValued];
                        finalDis += item[fieldDisplayed];
                        referData = item;
                        flag = true;
                        break;
                    }
                }
    
                let initVal = changedrows[index].oldvalue;
    
                let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                if (flag) {
                    let theValue = {
                        display: finalDis,
                        value: finalVal,
                    };
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: theValue.value || "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    //把最终值赋给queryvalue
                    row.values[attrcode].value = finalVal;
                    row.values[attrcode].display = finalDis;
                    ajaxValues.push(row);
                    referData && referDatas.push(referData);
                } else {
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    row.values[attrcode].value = "";
                    row.values[attrcode].display = "";
                    ajaxValues.push(row);
                    console.error(
                        cell,
                        "参照过滤没有匹配数据",
                    );
                }
            });
            return {
                indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
            };
        } else {
            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];
    
            queryValue.map((row, index) => {
                let initVal = changedrows[index].oldvalue;
                let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                newChangedRows.push({
                    rowid: row[rowKey],
                    newvalue: { value: "" },
                    oldvalue: { value: isRefpk || "" },
                });
                row.values[attrcode].value = "";
                row.values[attrcode].display = "";
                ajaxValues.push(row);
            });
            console.error(
                "参照过滤后返回的数组是空数组，没有查询到",
            );
            return {
                indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
            };
        }
    }
    
    function formatAccuracyNumber (val, scale = 8) {
        if (isNaN(val)) {
            return 0;
        }
        var powValue = Math.pow(10, scale);
        var res = val * powValue;
        res = Math.round(res);
        return parseInt(res, 10) / powValue;
    }

    return updateAfterBatchChange;
}